/* global I18n */

import React from "react"
import success_chocolate_img from
  "../../assets/images/video/success_chocolate.webp"

function FirstVideoCelebration({on_close}){
  return (
    <div className="milestone">
      <div className="close" onClick={on_close} />
      <div className="milestone__image">
        <img
          className="profile-picture"
          alt={I18n.t(
            "js.embedded_video.first_video_celebration.congratulations"
          )}
          src={success_chocolate_img}
        />
      </div>
      <div className="milestone__message">
        <div className="milestone__headline">
          {I18n.t("js.embedded_video.first_video_celebration.headline")}
        </div>
        <div className="milestone__copy">
          {I18n.t("js.embedded_video.first_video_celebration.your_first_video")}
        </div>
      </div>
    </div>
  )
}

export default FirstVideoCelebration
